<template>
  <div>
    <!-- 
author: {uid: "4c71325e2b4f41f3", name: "SSmJaE"}
name: "SSmJaE"
uid: "4c71325e2b4f41f3"
content: "1234567"
createTime: "2020-12-24 23:55:44"
id: 22
replyOther: false
reportId: 37
toUser: null 
-->
    <div class="reply-body">
      <span class="reply-author">
        <a target="_blank" :href="`/user/detail/${reply.author.name}`">
          {{ reply.author.name }}：
        </a>
      </span>
      <span class="reply-to" v-if="reply.replyOther">
        回复
        <a target="_blank" :href="`/user/detail/${reply.author.name}`">
          {{ reply.toUser.name }}：</a
        >
      </span>
      <span class="reply-content">{{ reply.content }}</span>
    </div>

    <div class="reply-footer">
      <span class="reply-time">{{ reply.createTime }}</span>
      <span class="reply-button" @click="showReplyForm = !showReplyForm"
        >回复</span
      >
    </div>

    <NewReply
      v-if="showReplyForm"
      :reportId="reportId"
      :replyTo="reply.id"
      @successSendNewReply="$emit('successSendNewReply')"
    />
  </div>
</template>

<script>
import NewReply from "./NewReply";

export default {
  props: {
    reportId: {
      type: Number,
      required: true,
    },
    reply: {
      type: Object,
      required: true,
    },
  },
  components: {
    NewReply,
  },
  data() {
    return {
      showReplyForm: false,
    };
  },
};
</script>

<style scoped>
.reply-footer {
  display: flex;
  justify-content: flex-end;
}
.reply-button {
  cursor: pointer;
  margin-left: 10px;
  color: rgb(23, 81, 153);
}
</style>